import { Array, Order, pipe, Record } from 'effect';

import type { GlossaryTermIndex } from '@vs-shop/schemas/branded/MiscSchema';

import { czechStringOrder } from './czechOrder';

/** Terms with no name land in a `#` bucket rather than disappearing. */
const firstLetterOf = (term: GlossaryTermIndex): string =>
  ((term.name ?? '')[0] ?? '#').toUpperCase();

const byFirstLetterEntry = Order.mapInput(
  czechStringOrder,
  ([letter]: readonly [string, readonly GlossaryTermIndex[]]) => letter
);

export const groupTermsByFirstLetter = (
  terms: readonly GlossaryTermIndex[]
): readonly (readonly [string, readonly GlossaryTermIndex[]])[] =>
  pipe(terms, Array.groupBy(firstLetterOf), Record.toEntries, Array.sortBy(byFirstLetterEntry));
